const imageItems = document.querySelectorAll('.hero-module__images-item');

if (imageItems.length > 0) {
  const mm = gsap.matchMedia();

  let isInViewport = false;

  const checkViewport = (entries) => {
    entries.forEach((entry) => {
      isInViewport = entry.isIntersecting;
    });
  };

  const observer = new IntersectionObserver(checkViewport, { threshold: 0.5 });

  imageItems.forEach((object, i) => {
    observer.observe(object);

    if (i > 14) {
      gsap.to(object, {
        immediateRender: true,
        left: () => `${gsap.utils.random(0, 100)}%`,
        top: () => `${gsap.utils.random(0, 100)}%`,
        maxWidth: () => `${gsap.utils.random(100, 155)}`,
        maxHeight: () => `${gsap.utils.random(120, 155)}`,
      });
    }
  });

  const moveObjects = (event) => {
    if (isInViewport) {
      mm.add('(min-width: 1199px)', () => {
        const offsetX = (event.clientX - window.innerWidth / 3) * 0.02;
        const offsetY = (event.clientY - window.innerHeight / 1) * 0.02;

        imageItems.forEach((object, index) => {
          const directionX = index % 3 === 0 ? 2 : -2;
          const directionY = index % 3 === 0 ? -2 : 2;
          const objectOffsetX = offsetX * directionX * (index + 2) * 0.2;
          const objectOffsetY = offsetY * directionY * (index + 2) * 0.2;
          gsap.to(object, { x: objectOffsetX, y: objectOffsetY, duration: 0.9 });
        });
      });
    }
  };

  document.addEventListener('mousemove', moveObjects);

  // Mobile animation
  mm.add('(max-width: 1198px)', () => {
    imageItems.forEach((item) => {
      gsap.to(item, {
        y: 'random(-50, 50)',
        duration: 1,
        scrollTrigger: {
          trigger: item,
          scrub: 1,
        },
      });
    });
  });

  // Open/Close Modal
  const allModals = document.querySelectorAll('.hero-module__modal');
  const toggleHeroModal = (element, toggle) => {
    element.classList.toggle('is-open-modal', toggle);
  };

  const closeAllModals = () => {
    allModals.forEach((modal) => {
      toggleHeroModal(modal, false);
    });
  };

  attachEvent('.hero-module__images-item', 'click', (ev) => {
    const parent = ev.target.closest('.sc-hero-module');
    const modalId = ev.target.getAttribute('data-item');

    closeAllModals();
    toggleHeroModal(parent.querySelector(`[data-modal="${modalId}"]`), true);

    ev.preventDefault();
  });

  attachEvent('[data-close-hero-modal]', 'click', () => {
    closeAllModals();
  });

  // Close Modal on ESC key press
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllModals();
    }
  });
}
